import { createGlobalStyle } from "styled-components";

// Non-critical styles that can be loaded after initial render
export const Styles = createGlobalStyle`
    /* Enhanced form styles */
    input:focus,
    textarea:focus {
        background: #333333;
        box-shadow: #6e4acf 0px 0px 0px 1px;
        transform: scale(1.01);
    }

    /* Animation and transition enhancements */
    * {
        transition: transform 0.2s ease-in-out;
    }

    a:hover {
        color: #cccccc;
        transform: translateY(-1px);
    }

    /* Advanced button styles */
    button:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(255,255,255,0.1);
    }

    /* Enhanced drawer styles */
    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
        background: #000000;
        backdrop-filter: blur(10px);
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
        box-shadow: -2px 0 8px rgba(255,255,255,0.15);
    }

    .ant-drawer-content {
        background: #000000;
    }

    .ant-drawer-header {
        background: #000000;
        border-bottom: 1px solid #444444;
    }

    /* Advanced image styles */
    .about-block-image svg {
        text-align: center;
        transition: all 0.3s ease-in-out;
    }

    .about-block-image svg:hover {
        transform: scale(1.05);
    }

    /* Form enhancements */
    input[type="submit"]:hover,
    button[type="submit"]:hover {
        background: linear-gradient(45deg, #6e4acf, #8e6adf);
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(110, 74, 207, 0.5);
    }

    /* Loading animations */
    @keyframes pulse {
        0% { opacity: 1; }
        50% { opacity: 0.5; }
        100% { opacity: 1; }
    }

    .loading {
        animation: pulse 1.5s infinite;
    }

    /* Advanced responsive enhancements */
    @media (prefers-reduced-motion: reduce) {
        *, *::before, *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
        }
    }

    /* Print styles */
    @media print {
        .ant-drawer,
        .ant-drawer-mask,
        button,
        .no-print {
            display: none !important;
        }
    }
`;
